'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HttpRequestError = function (_Error) {
    _inherits(HttpRequestError, _Error);

    function HttpRequestError() {
        var _ref;

        _classCallCheck(this, HttpRequestError);

        for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
            params[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = HttpRequestError.__proto__ || Object.getPrototypeOf(HttpRequestError)).call.apply(_ref, [this].concat(params)));

        _this.name = 'HttpRequestError';

        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, HttpRequestError);
        }
        return _this;
    }

    return HttpRequestError;
}(Error);

exports.default = HttpRequestError;